import React from 'react';
import styled from 'styled-components';
import Link from 'gatsby-link';
const StyledMenu = styled.ul``;

const Menu = ({ children, toggle }) => {
	return (
		<StyledMenu>
			<ul>
				<li>
					<Link onClick={toggle} to="/work">
						Work
					</Link>
				</li>
				<li>
					<Link onClick={toggle} to="/about">
						About
					</Link>
				</li>
				{/* <li>
					<a href="#">Blog</a>
				</li> */}
				<li>
					<Link onClick={toggle} to="/contact">
						Contact
					</Link>
				</li>
			</ul>
		</StyledMenu>
	);
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/index.js